<template>
  <AdminLayout>
    <Head title="Integration Flags" />

    <template #pageTitle>{{ integration.display_name }} Flags</template>

    <template #headingOptions>
      <div class="relative inline-flex self-start sm:my-5 h-10">
        <button
          v-if="showingActionButton"
          @click="deleteFlags()"
          class="justify-center w-full rounded-md border border-red-400 shadow-sm px-4 bg-red-400 text-sm font-medium text-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-red-400 focus:ring-red-400"
        >
          Delete
        </button>
      </div>
    </template>

    <DataGrid
      name="flags_data_table"
      :endpoint="route('api.tables.integration-flags.index', { integration: integration.id })"
      rowId="id"
      :filters="form"
      :columns="columns"
      :block-size="40"
      :page-size="40"
      :show-check-column="true"
    />
  </AdminLayout>
</template>

<script setup>
import AdminLayout from '@/Layouts/AdminLayout.vue'
import { Head, useForm } from '@inertiajs/vue3'
import { computed, ref } from 'vue'
import { useInitGridState } from '@/Components/DataGrid/Composables/grid-state'
import { useSelectedRowNodes } from '@/Components/DataGrid/Composables/selected-row-nodes'
import DateCell from '@/Components/DataGrid/Cells/DateCell.vue'
import DataGrid from '@/Components/DataGrid/Tables/Generic.vue'
import FlaggableCell from '@/Components/DataGrid/Cells/FlaggableCell.vue'
import ActivityResourceLinkCell from '@/Components/DataGrid/Cells/ActivityResourceLinkCell.vue'

const props = defineProps({
  integration: Object
})

const { context } = useInitGridState()

const { selectedRowNodeIds, totalSelectedRowNodes } = useSelectedRowNodes({
  gridApi: computed(() => context.gridApi)
})

const form = useForm({})
const actionForm = useForm({
  flags: []
})

const columns = ref([
  {
    headerName: 'ID',
    field: 'id',
    minWidth: 150
  },
  {
    headerName: 'Type',
    field: 'label',
    sortable: false
  },
  {
    headerName: 'Flaggable',
    cellRenderer: FlaggableCell,
    field: 'flaggable',
    sortable: false,
    minWidth: 300
  },
  {
    headerName: 'Activity',
    cellRenderer: ActivityResourceLinkCell,
    sortable: false,
    cellRendererParams: (params) => ({
      type: params.data.flaggable?.type,
      id: params.data.flaggable?.id
    })
  },
  {
    headerName: 'First Flagged',
    cellRenderer: DateCell,
    field: 'created_at'
  },
  {
    headerName: 'Last Update',
    cellRenderer: DateCell,
    field: 'updated_at'
  }
])

const showingActionButton = computed(() => totalSelectedRowNodes.value > 0)

const deleteFlags = () => {
  actionForm.flags = selectedRowNodeIds.value
  actionForm.post(route('company.integrations.flags.delete'), {
    onFinish: () => {
      actionForm.reset()
      context.refresh()
    }
  })
}
</script>
